// extracted by mini-css-extract-plugin
module.exports = {"s350o39":"s350o39","l10koj98":"l10koj98"};